/**
 * WEHAGO API 엔드포인트 설정
 * 원본: wehago-conference/src/config/wehago.js, wehagoDev.js
 *
 * VITE_APP_TYPE=dev(기본) → 개발 서버 (rtctest.wehago.com)
 * VITE_APP_TYPE=wehago 등 → 운영 서버 (api.wehago.com)
 */

const appType = (import.meta.env.VITE_APP_TYPE as string | undefined) ?? 'dev';
const isDev = appType === 'dev' || appType === 'productDev';

const devApiConfig = {
  guestEndpoint: 'videodev',
  baseGuestUrl: 'https://rtctest.wehago.com/api0',
  thumbnailBaseUrl: 'http://dev.api0.wehago.com/DCloudStorageServer/WehagoIMG',
  baseGuestVideoConferenceUrl: 'https://api0.wehago.com/videodev',
  baseApiUrl: 'https://rtctest.wehago.com/apip/communication/rtc/',
  baseGuestApiUrl: 'https://rtctest.wehago.com/api0/communication/rtc/',
  baseApiRootUrl: 'https://rtctest.wehago.com/',
  baseVideoApiUrl: 'https://rtctest.wehago.com/videodev/',
  baseProductApiRootUrl: 'https://rtctest.wehago.com/apip/',
  conferenceApiUrl: 'https://rtctest.wehago.com/apip',
  originalApiUrl: 'https://rtctest.wehago.com/apip',
  contactsApiUrl: 'https://rtctest.wehago.com/apip/contacts',
  portalBaseUrl: 'http://dev.wehago.com',
  weMeetAPI: {
    endpoint: '/api-bind',
    baseApiUrl: 'https://rtctest.wehago.com',
    // endpoint: '/videodev',
    // baseApiUrl: 'http://localhost:8080',
    baseWSUrl: 'wss://rtctest.wehago.com',
  },
  portal: {
    wehagoCommonApiUrl: 'https://rtctest.wehago.com/apip/common',
    unCertApiUrl: 'https://rtctest.wehago.com/api0',
  },
} as const;

const prodApiConfig = {
  guestEndpoint: 'video',
  baseGuestUrl: 'https://api0.wehago.com',
  thumbnailBaseUrl: 'https://api0.wehago.com/DCloudStorageServer/WehagoIMG',
  baseGuestVideoConferenceUrl: 'https://api0.wehago.com/video',
  baseApiUrl: 'https://api.wehago.com/communication/rtc/',
  baseGuestApiUrl: 'https://api0.wehago.com/communication/rtc/',
  baseApiRootUrl: 'https://api.wehago.com/',
  baseVideoApiUrl: 'https://api.wehago.com/video/',
  baseProductApiRootUrl: 'https://api.wehago.com/',
  conferenceApiUrl: 'https://api.wehago.com/remotecs',
  originalApiUrl: 'https://api.wehago.com',
  contactsApiUrl: 'https://api.wehago.com/contacts',
  portalBaseUrl: 'https://www.wehago.com',
  weMeetAPI: {
    endpoint: '/video',
    baseApiUrl: 'https://api.wehago.com',
    baseWSUrl: 'wss://socket.wehago.com',
  },
  portal: {
    wehagoCommonApiUrl: 'https://api.wehago.com/common',
    unCertApiUrl: 'https://api0.wehago.com',
  },
} as const;

const apiConfig = isDev ? devApiConfig : prodApiConfig;

export default apiConfig;
